import { connectHook } from 'app/common/components/connect-hook';
import { Link } from '../link/link';
import { useProjectLink } from './project-link-hook';

export default connectHook(Link, useProjectLink);
